/**
 * @generated SignedSource<<4b2d6f9c9be51aeb9a4674f4f9ff7fa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeTxnsInputObject = {
  name?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type stakeholderTxnsDialog_AttributeTxnsMutation$variables = {
  input: AttributeTxnsInputObject;
};
export type stakeholderTxnsDialog_AttributeTxnsMutation$data = {
  readonly attributeTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly suggestion: {
      readonly additionalCount: number;
      readonly matchKind: string;
      readonly regex: string;
      readonly totalCount: number;
    } | null | undefined;
  } | null | undefined;
};
export type stakeholderTxnsDialog_AttributeTxnsMutation = {
  response: stakeholderTxnsDialog_AttributeTxnsMutation$data;
  variables: stakeholderTxnsDialog_AttributeTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regex",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchKind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderTxnsDialog_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderTxnsDialog_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03a42c1d234edba1acf6d80952dde495",
    "id": null,
    "metadata": {},
    "name": "stakeholderTxnsDialog_AttributeTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderTxnsDialog_AttributeTxnsMutation(\n  $input: AttributeTxnsInputObject!\n) {\n  attributeTxns(input: $input) {\n    stakeholder {\n      id\n      name\n    }\n    suggestion {\n      regex\n      matchKind\n      additionalCount\n      totalCount\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77ef09f91d23bc54435dee0e28b805d5";

export default node;
